import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "preview-area" }
const _hoisted_3 = { class: "input-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Result = _resolveComponent("Result")!
  const _component_TextSource = _resolveComponent("TextSource")!
  const _component_Target = _resolveComponent("Target")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 登録ステータス表示 "),
    (_ctx.registrationStatus)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["registration-status", _ctx.registrationStatus])
        }, _toDisplayString(_ctx.registrationMessage), 3 /* TEXT, CLASS */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" プレビューエリア "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Result, {
        images: _ctx.resultImages,
        name: _ctx.name,
        emojiName: _ctx.emojiName,
        "existing-emojis": _ctx.existingEmojis,
        "registration-status": _ctx.registrationStatus,
        "show-target": _ctx.ui.showTargetPanel,
        onToggleShowTarget: _ctx.onToggleShowTarget,
        onRegistrationStart: _ctx.setRegistrationLoading
      }, null, 8 /* PROPS */, ["images", "name", "emojiName", "existing-emojis", "registration-status", "show-target", "onToggleShowTarget", "onRegistrationStart"])
    ]),
    _createCommentVNode(" 入力エリア "),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TextSource, {
        show: _ctx.ui.mode == 'text',
        "emoji-size": _ctx.emojiSize,
        "existing-emojis": _ctx.existingEmojis,
        onRender: _ctx.onRender
      }, null, 8 /* PROPS */, ["show", "emoji-size", "existing-emojis", "onRender"]),
      _createVNode(_component_Target, {
        "emoji-size": _ctx.emojiSize,
        "onUpdate:emojiSize": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emojiSize) = $event)),
        show: _ctx.ui.showTargetPanel,
        "base-image": _ctx.baseImage,
        onRender: _ctx.onRenderTarget
      }, null, 8 /* PROPS */, ["emoji-size", "show", "base-image", "onRender"])
    ])
  ]))
}